import React from "react";
import { Routes, Route } from "react-router-dom";
import ChatHome from "./chatwindow/ChatHome";
import LogoutPage from "./general/LogoutPage";

const Pages = () => (
    <div>
        <Routes>
            <Route path="/" element={<ChatHome />} />
            <Route path="/logout" element={<LogoutPage />} />
        </Routes>
    </div>
);

export default Pages;
